import { useRef } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Portfolio from './components/Portfolio';
import Structures from './components/Structures';
import Services from './components/Services';
import Tagline from './components/Tagline';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import { useCinematicMotion } from './motion';

function App() {
  const root = useRef(null);
  useCinematicMotion(root);

  return (
    <div ref={root}>
      <a className="skip" href="#conteudo">
        Pular para o conteúdo
      </a>
      <Navbar />
      <main id="conteudo">
        <Hero />
        <Portfolio />
        <Structures />
        <Services />
        <Tagline />
        <About />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
